import React from 'react';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import 'rc-tabs/assets/index.css';
import { isEqual, isEmpty } from 'lodash';
import './Tabstyle_38.css';

//对话框1
export default class Tabstyle_38 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tabid: this.props.tabid
        }
        this.handleTabData = this.handleTabData.bind(this);
    }

    handleTabData(tabid){
        const { datas={} } = this.props;
        const { handleTabData={} } = datas;
        handleTabData(tabid);
        this.setState({
            tabid: tabid
        })
    }

    componentWillReceiveProps(nextProps){
        const { tabid } = this.state;
        if(!isEqual(tabid, nextProps.datas.currentTab)){
            this.setState({
                tabid: nextProps.datas.currentTab
            })
        }
    }

   
    
    render(){     
        const { datas={}, fontStyle, ebaseid = '' } = this.props;
        const { tabid } = this.state;
        const { isShowSettingShowType='0' } = datas;
        if(isEmpty(datas)) return <div/>;
        const { currentTab='1', tabids = [], titles = [], methodvalue,tabwidth,counts } = datas;
        let titleStyle = {width: '100%'};
        const cbtdStyle={width: 'auto', verticalAlign: 'top',backgroundSize: '100% 100%', height: '51px',  paddingTop: '0px', borderBottomColor: 'transparent', backgroundImage: 'url()'};
        const cbtdStyle1={width: 'auto',  verticalAlign: 'top',backgroundSize: '100% 100%', height: '51px',  paddingTop: '0px', borderBottomColor: 'transparent', backgroundImage: 'url()'};
        let cbstyle = {height:'42px',paddingLeft: '8px', paddingRight: '8px'};
        let cbstyle1 = {height:'42px',width: tabwidth + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block',padding:'0px 8px'};
        let tHtml_new = (
            <div className='commonTab Tabstyle_38' id='Tabstyle_38'>
                <Tabs ecId={`${this && this.props && this.props.ecId || ''}_Tabs@0zy1e6`}
                activeKey={tabid}
                renderTabBar={()=><ScrollableInkTabBar ecId={`${this && this.props && this.props.ecId || ''}_ScrollableInkTabBar@4grx2h`} />}
                renderTabContent={()=><TabContent ecId={`${this && this.props && this.props.ecId || ''}_TabContent@88mvfd`} />}
                className="tabcontainer tab2"
                style={titleStyle}
                >
                {
                    titles.map((title, i)=> {
                        if ((ebaseid == '8') && counts && counts[i] !== -1 && counts[i] !== '' && counts[i] !== null) {
                            if(counts[i] > 99){
                                title +='(99+)';
                            }else {
                                title +=' (' + counts[i] + ')';
                            }
                        }else if (ebaseid == 'blogStatus' && counts && '0'!== counts[i]) {
                            title += ' (' + counts[i] + ')';
                        }else if(ebaseid == '7_DY'&& counts && '0'!== counts[i]){
                            title += ' (' + counts[i].noReadNum + ')';
                        }else if(isShowSettingShowType == '1' && ebaseid == '7'&& counts && counts[i] && counts[i].noReadNum){
                            title += ' (' + counts[i].noReadNum + ')';
                        }else if(ebaseid == '7'&& counts && counts[i] && counts[i].isHaveNoRead && counts[i].isHaveNoRead == '1'){
                            title =  title;
                        }
                        let contabgstyle='0px 0px 0px 0px';
                        let borderrig='1px';
                        if(i==0){
                            contabgstyle='5px 0px 0px 5px';
                        }else if(titles.length == i+1){
                            contabgstyle='0px 5px 5px 0px';
                            borderrig='0px'
                        }
                        const className = tabids[i] == tabid ? `tab2selected wea-f${fontStyle.tab1fontsize || 12} ` : `tab2unselected wea-f${fontStyle.tab2fontsize || 12}`;
                        const pointClassName = ebaseid == '7'&& counts && counts[i] && counts[i].isHaveNoRead && counts[i].isHaveNoRead == '1' ? 'portal-new-unreadpoint' : '';
                        let tabTextStyle=pointClassName==''?{display:'inline-block',width:'100%',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}:{display:'inline-block',width:'calc(100% - 10px)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}
                    return  <TabPane ecId={`${this && this.props && this.props.ecId || ''}_TabPane@oxis1v@${tabids[i]}`} key={tabids[i]} style={{width: 'auto'}} tab={
                                    <div    title={title} 
                                            className={className} 
                                            style={methodvalue == '2' ? cbtdStyle1 : cbtdStyle} data-tabid={tabids[i]}  
                                            onClick={() => this.handleTabData(tabids[i])}
                                    >
                                        <div className='containbg' style={{borderRadius:contabgstyle}}>
                                            <div className={`tabcolor colorbartitle`}>
                                                <div className='style_38_show'style={methodvalue == '2' ? cbstyle:cbstyle1}>
                                                    <div style={tabTextStyle}>{title}</div>
                                                    <div className={pointClassName} style={{position:'relative',top:'-15px'}}></div>
                                                </div>
                                                {tabids[i] == tabid||tabids[i+1]==tabid?null:<div className={`tabsplit_38`} style={{width:borderrig}}></div>}
                                            </div>
                                        </div>

                                        <div className={`tabcolor-sel colobar-selecttra`}></div>
                                    </div>
                                }>
                                </TabPane>
                    })
                }
            </Tabs>
            </div>
        )
        return tHtml_new;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/tabstyle/38/Tabstyle_38.js